import { Loading } from '@components/atomic/atoms';
import { OETrans } from '@components/translation/OETrans';
import { getAllInvolvedSubjectsByFrameworkContract, getOeSubjectRoles } from '@lib/api';
import { dateFormatter } from '@lib/helpers/formatting';
import { useQuery } from '@tanstack/react-query';
import React, { Fragment } from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';

interface SummaryFrameworkcontractModalInvolvedSubjectsProps {
	frameworkcontractId: number;
}

const SummaryFrameworkcontractModalInvolvedSubjects: React.FC<SummaryFrameworkcontractModalInvolvedSubjectsProps> = ({
	frameworkcontractId,
}) => {
	const { data: optionsSubjectRoles, isPending: isPendingOptionsSubjectRoles } = useQuery<
		{
			data: { code: string; name: string }[];
		},
		unknown,
		{ value: string; label: string }[]
	>({
		queryKey: ['subjectRoles'],
		queryFn: () => getOeSubjectRoles(),
		select: (data) => {
			return data.data.map((item) => ({ value: item.code, label: item.name }));
		},
		// enabled: show,
	});

	const { data: involvedSubjects, isPending: isPendingInvolvedSubjects } = useQuery({
		queryKey: ['involvedSubjects', frameworkcontractId],
		queryFn: () => getAllInvolvedSubjectsByFrameworkContract(frameworkcontractId),
		enabled: !!frameworkcontractId,
	});

	if (isPendingInvolvedSubjects || isPendingOptionsSubjectRoles) return <Loading />;
	return (
		<>
			{involvedSubjects.length > 0 ? (
				involvedSubjects.map((el, index) => {
					return (
						<Fragment key={'involvedSubjects-' + index}>
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey={index}>
									<Accordion.Header>
										<span className="align-middle">
											<OETrans code="common.subject" fallback={'Soggetto'} />
											&nbsp;{index + 1}
										</span>
									</Accordion.Header>
									<Accordion.Body>
										<Row>
											<Col className="col-4">
												<Form.Group as={Col} className="pe-2">
													<Form.Label className="mb-3">
														<OETrans code="involvedsubjects.role" fallback={'Ruolo'} />
													</Form.Label>
													<Form.Text as="p">
														{el.role ? optionsSubjectRoles.filter((opt) => opt.value === el.role).map((el) => el.label) : 'N.D.'}
													</Form.Text>
												</Form.Group>
											</Col>
											<Col className="col-4">
												<Form.Group as={Col} className="pe-2">
													<Form.Label className="mb-3">
														<OETrans code="involvedsubjects.name" fallback={'Nome'} />
													</Form.Label>
													<Form.Text as="p">{el.name ?? 'N.D.'}</Form.Text>
												</Form.Group>
											</Col>
											<Col className="col-4">
												<Form.Group as={Col} className="pe-2">
													<Form.Label className="mb-3">
														<OETrans code="involvedsubjects.vatnumber" fallback={'Partita IVA'} />
													</Form.Label>
													<Form.Text as="p">{el.vatNumber ?? 'N.D.'}</Form.Text>
												</Form.Group>
											</Col>
										</Row>

										<Row>
											<Col className="col-4">
												<Form.Group as={Col} className="pe-2">
													<Form.Label className="mb-3">
														<OETrans code="involvedsubjects.countrycode" fallback={'Prefisso Internazionale'} />
													</Form.Label>
													<Form.Text as="p">{el.countryCode ?? 'N.D.'}</Form.Text>
												</Form.Group>
											</Col>
											<Col className="col-4">
												<Form.Group as={Col} className="pe-2">
													<Form.Label className="mb-3">
														<OETrans code="involvedsubjects.subscriptiondate" fallback={'Data di sottoscrizione'} />
													</Form.Label>
													<Form.Text as="p">{el.subscriptionDate ? dateFormatter(el.subscriptionDate) : 'N.D.'}</Form.Text>
												</Form.Group>
											</Col>
											<Col className="col-4">
												<Form.Group as={Col} className="pe-2">
													<Form.Label className="mb-3">
														<OETrans code="involvedsubjects.validityperiod" fallback={'Periodo di validità'} />
													</Form.Label>
													<Form.Text as="p">{el.validityPeriod ?? 'N.D.'}</Form.Text>
												</Form.Group>
											</Col>
											{/* <Col className='col-4'>
                                                       <Form.Group as={Col} className='pe-2'>
                                                          <Form.Label className='mb-3'>
                                                             <OETrans code='involvedsubjects.dl772021' fallback={'D.L. 77/2021'} />
                                                          </Form.Label>
                                                          <Form.Text as='p'>
                                                             {el.dl772021 ?? 'N.D.'}
                                                          </Form.Text>
                                                       </Form.Group>
                                                    </Col> */}
										</Row>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Fragment>
					);
				})
			) : (
				<OETrans code="common.opportunity.noitemsfound" fallback={'Nessun elemento trovato'} />
			)}
		</>
	);
};

export default SummaryFrameworkcontractModalInvolvedSubjects;
